import { useOkapiKy } from "@folio/stripes/core";
import { fetchUserById } from "../api/userService";
import { useDetailEntity } from "./useDetailEntity";
export var useUserActions = function () {
    var kyInstance = useOkapiKy();
    var _a = useDetailEntity("user-detail", function (id) {
        return fetchUserById(kyInstance, id);
    }), selectedItem = _a.selectedItem, handleRowClick = _a.handleRowClick, handleCloseDetail = _a.handleCloseDetail;
    return {
        selectedUser: selectedItem,
        handleRowClick: function (user) { return handleRowClick(user.id); },
        handleCloseDetail: handleCloseDetail,
    };
};
